export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7606.7cbb6759.jpg";